/**
 * @method scrollToElement
 * @param {Element} frame
 * @param {Element|String} elementIdOrObject
 */
const scrollToElement = (frame, elementIdOrObject) => {
  let elementObject = elementIdOrObject;

  if (typeof elementIdOrObject === 'string') {
    if (elementIdOrObject === '') {
      // An empty string will sometimes be used to reference the beginning of the document.
      // We don't have a DOM element, but we don't need to throw an error in this case.
      frame.parentElement.parentElement.scrollTop = 0;
      return;
    }

    // However, if the element is a defined string, it should exist in the document.
    elementObject = frame.contentDocument.getElementById(elementIdOrObject);

    if (!elementObject) {
      throw new Error(
        'Failed to scroll to element. Could not obtain target element.',
      );
    }
  }

  frame.parentElement.parentElement.scrollTop = Math.ceil(
    elementObject.getBoundingClientRect().top,
  );
};

export default scrollToElement;
